module.exports = __webpack_public_path__ + "img/viv2025.fba7c17f.jpg";